var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#999",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M5 9.629c0-1.62 0-2.43.327-3.05a2.949 2.949 0 0 1 1.311-1.264C7.28 5 8.12 5 9.8 5h8.4c1.68 0 2.52 0 3.162.315.565.278 1.023.72 1.311 1.265C23 7.198 23 8.008 23 9.629v5.496c0 1.348 0 2.022-.228 2.553a2.948 2.948 0 0 1-1.624 1.566c-.551.22-1.25.22-2.648.22-.489 0-.733 0-.96.052a2.03 2.03 0 0 0-.822.396c-.178.144-.325.332-.618.71l-1.46 1.877c-.217.279-.326.418-.459.468a.517.517 0 0 1-.362 0c-.133-.05-.242-.19-.459-.468L11.9 20.62c-.293-.377-.44-.565-.619-.709a2.03 2.03 0 0 0-.822-.396c-.226-.052-.47-.052-.959-.052-1.398 0-2.097 0-2.648-.22a2.949 2.949 0 0 1-1.624-1.566C5 17.148 5 16.474 5 15.125V9.629Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#999",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M9.5 12.5h.01m4.49 0h.01m4.49 0h.01m-8.51 0a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Zm4.5 0a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Zm4.5 0a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReview);
export default __webpack_public_path__ + "static/media/review.bf5dbde80c10da4f388295c8798ca308.svg";
export { ForwardRef as ReactComponent };